import { Injectable } from '@angular/core';
import { UserService } from '../classes/User/user.service';
import { ToolsService } from './tools.service';
import { ModulesManagerService } from '../classes/Module/modules-manager.service';

@Injectable()

export class TraductionService {

  private Translate: Object = {
    fra: {
      STR_HOME: "Accueil",
      STR_WELCOME_ON_KUERLOG: "Bienvenue sur CAPILITE",
      STR_USE_AS_ANONYME: "Utiliser sans compte",
      STR_LOGIN: "Connexion",
      STR_SEND_TO: "À: {Email}",
      STR_RECEIVE_FROM: "De: {Email}",
      STR_REGISTER: "Créer un compte",
      STR_PASSWORD: "Mot de passe",
      STR_DELETE_ACCOUNT: "Supprimer le compte",
      STR_DELETE_ACCOUNT_DESCRIPTION: "Votre compte et l'ensemble de vos déclarations sera supprimé dans 30 jours à compter de la demande de suppression. Vous pouvez récupérer votre compte avant ce délai de 30 jours en vous y reconnectant. Passé ce délai votre compte ainsi que les déclarations, chats et documents sera supprimé définitivement.",
      STR_CURRENT_PASSWORD: "Mot de passe actuel",
      STR_UNABLE_TO_DELETE_ASK: "Impossible de supprimer la déclaration...",
      STR_ASK_DELETED: "Déclaration supprimée",
      STR_ASK_GONA_BE_DELETE: "La déclaration sera supprimée dans 30 jours.",
      STR_NEW_PASSWORD: "Nouveau mot de passe",
      STR_CHANGE_PASSWORD: "Changer de mot de passe",
      STR_CONFIRME_PASSWORD: "Confirmer le mot de passe",
      STR_MY_PROFILE: "Mon compte",
      STR_FILTERS: "Filtres",
      STR_WHERE_I_M_ASKER: "Mes déclarations",
      STR_WHERE_I_M_TARGET: "Déclaration dont je suis responsable",
      STR_WHERE_I_M_SHARED: "Déclaration que l'on me partage",
      STR_SHOW_ONLY_SOON_DELETED_ASK: "Uniquement les déclarations en cours de suppression",
      STR_HIDE_SOON_DELETED_ASK: "Retirer les déclarations en cours de suppression",
      STR_MAIL_NOT_VALIDE: "Email invalide",
      STR_EMAIL_SEND_IF_GOOD_MAIL: "Si votre mail existe un email vous sera envoyé pour recréer votre mot de passe",
      STR_ENTER_MAIL: "Saisissez votre email",
      STR_PASSWORD_MISS_MATCH: "Mot de passe différent",
      STR_EMAIL_ALLREADY_USED: "Email déjà utilisé",
      STR_CONFIRME_EMAIL_HAS_SEND: "Un mail de confirmation vous a été envoyé",
      STR_CONFIRME_EMAIL_CREATE_ASK: "Pour confirmer l'envoi de votre demande ......",
      STR_ASK_SENDED: "Votre demande a été envoyée",
      STR_REQUIRED_FIELD: "Champ requis",
      STR_LOGOUT: "Déconnexion",
      STR_ABOUT: "À propos",
      STR_ASK: "Déclaration",
      STR_ASKS: "Suivi des demandes",
      STR_ASKS_FOOT: "Suivi",
      STR_ANONYMOUS: "Anonyme",
      STR_ANONYMOUS_MODE: "Mode anonyme",
      STR_LANGUAGES: "Langues",
      STR_UNABLE_OFFLINE: "Action impossible en mode Hors Connexion",
      STR_OK: "Ok",
      STR_CANCEL: "Annuler",
      STR_RETURN: "Retour",
      STR_CLOSE: "Fermer",
      STR_CONFIRME: "Confirmer",
      STR_TRANSFERT_ASK_TO_USER: "Transferer la déclaration à l'utilisateur",
      STR_ASK_TRANSFERRED: "La déclaration a été transférée",
      STR_UNABLE_DELETE_ORIGINAL_ASK_OWNERS: "Impossible de supprimer les propriétaires de la déclaration",
      STR_NOT_AVAIBLE_NOW: "Indisponible pour l'instant",
      STR_NOT_AVAIBLE_NOW_DESCRIPTION: "Le 'mode hors ligne' n'est pas disponible pour le moment. Veuillez réessayer avec une connexion réseau. Si le problème persiste, veuillez contacter notre équipe.",
      STR_METHODE_CHOICE: "Choisissez une méthode",
      STR_DOCUMENT_PICKER: "Explorateur",
      STR_USE_CAMERA: "Appareil photo",
      STR_HOW_SHOULD_IMPORT_DOCUMENT: "Comment souhaitez vous importer des documents?",
      STR_CHAT: "Chat",
      STR_UNDEFINED_TITLE: "Titre non défini",
      STR_CONTACTS: "Contacts",
      STR_VIEW_CONTACT: "Voir le contact",
      STR_ADD_TO_CONTACTS: "Ajouter aux contacts",
      STR_ASK_TITLE: "Titre de la déclaration",
      STR_ASK_DESCRIPTION: "Description",
      STR_ASK_EDIT: "Éditer la déclaration",
      STR_ASK_SHOWGEOLOCATION: "Indiquer la position",
      STR_ASK_GEOLOCATION: "Géolocalisation",
      STR_ASK_DOCUMENTS: "Joindre pièce(s) jointe(s)",
      STR_ASK_CURRENT_DATE: "Demandée le",
      STR_ASK_CREATE_ACCOUNT: "Créer un compte?",
      STR_ERROR: "Une erreur est survenue...",
      STR_FULLDATE: "dd/mm/yyyy hh:ii",
      STR_FULLDATE_SHOW: "dd/mm/yyyy à hh:ii",
      STR_DELETE_AT: "Sera supprimée le {Date}",
      STR_CHAT_DELETE_AT: "La demande sera supprimée le {Date}, à compter de cette date elle ne sera plus accessible",
      STR_FULLDATE_DATETIME_PICKER: "yyyy-mm-ddThh:ii",
      STR_CREA_ASK: "Déclarer",
      STR_CREA_ASK_TITLE: "Nouvelle déclaration",
      STR_SEND: "Envoyer",
      STR_COORDINATES: "Vos coordonnées",
      STR_FIRSTNAME: "Prénom",
      STR_LASTNAME: "Nom",
      STR_EMAIL: "Adresse mail",
      STR_PHONE_NUMBER: "Numéro de téléphone",
      STR_SOCIETY: "Société",
      STR_PROFESSIONAL_USAGE: "pour une utilisation professionnelle",
      STR_FAIL_EMAIL: "Merci de fournir une adresse email valide",
      STR_FAIL_TARGET: "Email ou société invalide",
      STR_UNKNOW_SOCIETY: "Société inconnue",
      STR_CHAT_DISABLED_WILL_CREATING: "Le chat est désactivé pendant la rédaction",
      STR_SUCCESS_CREA_ASK: "Votre déclaration a bien été créée",
      STR_SUCCESS_CREA_MAIL: "Merci de confirmer votre demande en cliquant sur le lien envoyé par mail",
      STR_PLACEHOLDER: "Saisissez du texte",
      STR_PLACEHOLDER_SEARCH: "Recherchez...",
      STR_PLACEHOLDER_FIRSTNAME: "Saisissez votre prénom",
      STR_PLACEHOLDER_LASTNAME: "Saisissez votre nom",
      STR_PLACEHOLDER_PASSWORD: "Saisissez votre mot de passe",
      STR_PLACEHOLDER_PHONE_NUMBER: "Saisissez un numéro",
      STR_DISPLAY_PHONE_NUMBER: "Ajouter mon numéro lors d'une déclaration",
      STR_ASKER_PHONE_NUMBER: "Téléphone du demandeur",
      STR_ASKER_PHONE_NUMBER_PLACEHOLDER: "Saisissez votre téléphone",
      STR_WRONG_PHONE_NUMBER_FORMAT: "Numéro invalide",
      STR_ENTER_ADDRESSE: "Saisissez une adresse ou un lieu",
      STR_SCAN: "Scanner",
      STR_LOADING: "Chargement...",
      STR_NO_GPS: "Veuillez vérifier votre GPS ou les permissions de l'application",
      STR_EMPTY: "Vide",
      STR_NOT_SUPPORTED: "Cette fonctionnalité n'est pas supportée par votre appareil...",
      STR_NO_PERMISSION: "Permission refusée",
      STR_NO_FOLDER_FOUND: "Dossier {folder} non trouvé",
      STR_NO_FILE_FOUND: " Fichier {file} non trouvé",
      STR_FILE_ALLREADY_EXIST: "Document déjà existant",
      STR_UPLOAD_SUCCESS: "Document envoyé",
      STR_DATA_UPDATE_SUCCESS: "Données mises à jour",
      STR_EQUIPEMENT: "Équipement",
      STR_FILE_ALLREADY_EXIST_SERVER_SIDE: "Document déjà existant sur le serveur",
      STR_CANT_JOIN_SERVER: "Impossible de se connecter au serveur....",
      STR_ERROR_SERVER: "Une erreur est survenue sur le serveur...",
      STR_SERVER_SHUTDOWN: "Le serveur a coupé la connexion...",
      STR_WRONG_TOKEN: "Le token est invalide ou déjà utilisé...",
      STR_TOKEN_SUCCESS: "Valide",
      STR_INCATIVE_ACCOUNT: "Vous n'avez pas validé votre Email",
      STR_PASSWORD_CHANGED: "Le mot de passe a été changé",
      STR_TOKEN_USERS_SUCCESS: "Compte activé...",
      STR_TOKEN_ASKS_SUCCESS: "Demande envoyée",
      STR_WRONG_CREDITENTIAL: "Identifiant invalide",
      STR_CONNECTED: "Connecté",
      STR_MISSING_IMPOSED_VALUE: "Veuillez remplir tous les champs imposés",
      STR_IMPOSED_FIELD: "* Champ imposé",
      STR_EXTERNAL_REFERENCE: "Référence: {Ref}",
      STR_PLEASE_WAIT: "Veuillez patienter",
      STR_EDIT: "Éditer",
      STR_EDITING: "Édition",
      STR_CREATING: "Attente de vérification",
      STR_NEW: "Demandé",
      STR_TODO: "À faire",
      STR_RUNNING: "En cours",
      STR_OVER: "Terminé",
      STR_ARCHIVED: "Archivé",
      STR_ARCHIVE: "Archiver",
      STR_ARCHIVE_DESCRIPTION: "Voulez-vous vraiment archiver {x} déclaration(s) ?",
      STR_REPORT: "Votre compte-rendu...",
      STR_STATES: "Statut",
      STR_RECEIVE_ASK: "Réceptionner cette déclaration",
      STR_RECEIVE: "Réceptionner",
      STR_SAVE: "Enregistrer",
      STR_NEW_CONTACT: "Nouveau contact",
      STR_CONTACT_DELETED: "Contact supprimé",
      STR_CONTACT_DELETE_CONFIRM: "Êtes-vous sûr de vouloir supprimer ce contact ?",
      STR_DOCUMENT_DELETE_CONFIRM: "Êtes-vous sûr de vouloir supprimer ce document ?",
      STR_ASK_RECEIVE_CONFIRM: "Êtes-vous sûr de vouloir réceptionner cette déclaration ?",
      STR_DELETE: "Supprimer",
      STR_ASK_DELETE_CONFIRM: "Êtes-vous sûr de vouloir supprimer cette déclaration ?",
      STR_NEW_CONTACT_DESCRIPTION: "Un nouveau contact a été ajouté dans votre annuaire",
      STR_CONTACT_CREATED: "Contact créé",
      STR_CONTACT_ALREADY_EXIST: "Email déjà enregistré dans vos contacts",
      STR_RECEIVED: "Déclaration réceptionnée par {DisplayName}",
      STR_RECEIVED_SHORT: "Réceptionnée",
      STR_NOT_RECEIVED_SHORT: "Non réceptionnée",
      STR_USER_HAS_CHANGE_STATE: "A changé le statut pour: {States}",
      STR_YOU_RECEIVED: "Vous avez réceptionné cette déclaration",
      STR_TARGET_EMAIL: "Destinataire",
      STR_TARGET_EMAIL_PLACEHOLDER: "Saisissez une adresse mail",
      STR_NO_VALUE_SELECTED: "Aucune valeur sélectionnée",
      STR_BEGIN: "Commencer",
      STR_VALIDATE: "Valider",
      STR_YOUR_EMAIL: "Votre adresse mail",
      STR_FORGOTTEN_PASSWORDD: "Mot de passe oublié ?",
      STR_PLEASE_PROVIDE_TARGET: "Vous devez saisir un destinataire",
      STR_PLEASE_PROVIDE_YOUR_MAIL: "Vous devez saisir votre email",
      STR_PLEASE_PROVIDE_YOUR_LASTNAME: "Vous devez saisir votre nom",
      STR_PLEASE_PROVIDE_TEXT: "Vous devez saisir du texte",
      STR_DARK_MODE: "Mode sombre",
      STR_TERMS: "Conditions générales",
      STR_TERMS_ACCEPT: "Je reconnais avoir lu et accepté les Conditions Générales d'Utilisation",
      STR_DATA_TRANFERT_ACCEPT: "J'autorise le transfert de mes données pour traitement vers un logiciel tiers",
      STR_ACCEPT: "Accepter",
      STR_TERMS_NOT_ACCEPTED: "Veuillez accepter les conditions.",
      STR_CONFIDENTIALITY: "Confidentialité",
      STR_LOGO_BASELINE: "Déclaration et suivi d'incidents et pannes",
      STR_FLAG: 'fr',
      STR_VERSION: 'Version: {version}',
      STR_ASK_NOT_PRESENT_ON_DEVICE: 'La déclaration n\'est pas présente sur votre appareil. Pour la retrouver, merci de créer un compte ou rendez-vous sur le support depuis lequel vous avez créé la déclaration.',
      STR_ASK_NOT_PRESENT_ON_DEVICE_HEADER: "Déclaration non présente sur l'appareil",
      STR_MODIFICATIONS_SAVED: "Modification(s) enregistrée(s)",
      STR_SCROLL_TO_ACCEPT: "Vous devez lire les CGU pour pouvoir valider.",
      STR_ADMIN_VIEW: "Administration",
      STR_ADMINISTRATOR: "Administrateur",
      STR_CATEGORY: "Categorie",
      STR_USERS: "Utilisateurs",
      STR_MODULE_NOT_FOUND: "Module introuvable",
      STR_API: "API",
      STR_DISABLED: "Désactivé",
      STR_ENABLED: "Activé",
      STR_CREDITS_LEFT: "Credit restant: {Credits}",
      STR_ACCOUNT_TYPE_PUBLIC: "Public",
      STR_ACCOUNT_TYPE_ADMIN: "Admin",
      STR_ACCOUNT_TYPE_ACTIVE: "Actif",
      STR_ACCOUNT_TYPE_ANONYME: "Anonyme",
      STR_LAST_CONNECTION_DATE: "Dernière connexion",
      STR_CREATED_DATE: "Date de création",
      STR_CGU_UP_TO_DATE: "CGU à jour",
      STR_CGU_ACCEPTED_AT: "CGU accepté le",
      STR_CGU_VERSION: "Version CGU",
      STR_YES: "Oui",
      STR_NO: "Non",
      STR_STATUS: "Statuts",
      STR_ACTIVE: "Actif",
      STR_CREDITS: "Crédits",
      STR_CREATE: "Créer",
      STR_API_IN: "Entrant",
      STR_API_OUT: "Sortant",
      STR_API_TYPE: "Type D'API",
      STR_NOT_ADMIN: "Vous n'êtes pas administrateur",
      STR_PUBLIC_LABEL: "Label Public",
      STR_INTERNAL_LABEL: "Label Interne (compte capilog)",
      STR_API_LINK: "Lien API",
      STR_SECURE_CODE: "Code sécurité",
      STR_ALLREADY_USED: "Déjà utilisé",
      STR_UNABLE_TO_CREATE: "Impossible de créer",
      STR_UNABLE_TO_UPDATE: "Impossible de mettre à jour",
      STR_UPDATE_SUCCESS: "Modifications enregistrées",
      STR_SUCCESS_CREATE: "Création réussie",
      STR_PENDING_SYNC: "Synchronisation en cours",
      STR_NOT_VERIFIED: "Email non vérifié, veuillez vérifier vos emails",
      STR_PROJET_OWNER_EMAIL: "Email du responsable projet",
      STR_BASE_ON_TOKEN: "Basé sur les jetons",
      STR_EXPIRE_DATE: "Date d'expiration",
      STR_KEEP_CONNECTED_FOR: "Rester connecté durant (HH:MM)",
      STR_STAY_CONNECTED: "Rester connecté ( affaiblit la sécurité de votre compte )",
      STR_INVALID_TOKEN: "Token non valide",
      STR_MANAGE_MY_DEVICES: "Gérer mes appareils",
      STR_MANAGE_DEVICES: "Gérer les appareils",
      STR_CREATED_AT: "Créé le {date}",
      STR_UNKNOWN: "Inconnu",
      STR_TOKEN_DELETED: "Accès supprimé",
      STR_DELETE_TOKEN: "Supprimer l'accès",
      STR_DELETE_TOKEN_DESCRIPTION: "Voulez-vous vraiment supprimer cette accès?",
      STR_SHARED_WITH: "Partage avec:",
      STR_SHARE_SUCCESS: "Partage réussi",
      STR_SHARE: "Partager",
      STR_SHARE_DELETE_CONFIRM: "Êtes-vous sûr de vouloir retirer cette personne de la liste?",
      STR_DELETE_SELECTED_ASKS: "Êtes-vous sûr de vouloir supprimer les {x} déclaration(s)? Toutes les déclarations déjà en cours seront supprimées dans 30 jours.",
      STR_GET_STATEMENT_BACK_TO_OWNER: "Récupérer la déclaration",
      STR_GET_STATEMENT_BACK_TO_TARGET: "Rendre la déclaration",
      STR_VIEW_MY_STATS: "Voir mes statistiques",
      STR_USE_OUR_EMAIL_SERVICE: "Utiliser le mail CapiLite",
      STR_UPDATE: "Mettre à jour",
      STR_UPDATER_TITLE_LOW: "Mise à jour {NextVersion}",
      STR_UPDATER_MSG_LOW: "Une Mise à jour est disponible sur le store. Nous vous recommandons de mettre à jour votre application.",
      STR_UPDATER_TITLE_HIGH: "Mise à jour Majeure {NextVersion}",
      STR_UPDATER_MSG_HIGH: "Une Mise à jour Majeure est disponible. Merci de mettre à jour votre application pour continuer d'utiliser CapiLite.",
      STR_UPDATER_TITLE_MAINTENANCE: "Maintenance en cours",
      STR_UPDATER_MSG_MAINTENANCE: "CapiLite est en maintenance. Merci de patienter et de réessayer plus tard. Merci de votre patience.",
      STR_PASSWORD_TOO_SHORT: "6 caractères minimum.",
      STR_HAVE_ASKS_TO_VALIDATE: "vous avez des demandes en attente de vérification dans vos mails",
      STR_HAVE_TO_VALIDATE_ASK: "Vous avez reçu un mail, veuillez confirmer la déclaration depuis ce mail",
      STR_PLEASE_ENABLE_CAMERA: "Veuillez autoriser l'accès à l'appareil photo dans vos paramètres",
      STR_INTERLOCUTORS: "Interlocuteurs",
      STR_TO_COMPLETE: "À compléter",
      STR_ATTEMPT_DELETE_X: "Supprimer {x} déclaration(s)",
      STR_ATTEMPT_ARCHIVE_X: "Archiver {x} déclaration(s)",
      STR_SUCCESS_ARCHIVE: "Archivage réussi",
      STR_RECEIVED_ASK: "Déclaration réceptionnée",
      STR_NOT_RECEIVED_ASK: "Déclaration non réceptionnée",
    },
    eng: {
      STR_HOME: "Home",
      STR_WELCOME_ON_KUERLOG: "Welcome to CAPILITE",
      STR_USE_AS_ANONYME: "Use anonymously",
      STR_LOGIN: "Login",
      STR_SEND_TO: "To: {Email}",
      STR_RECEIVE_FROM: "From: {Email}",
      STR_REGISTER: "Create an account",
      STR_PASSWORD: "Password",
      STR_DELETE_ACCOUNT: "Delete account",
      STR_DELETE_ACCOUNT_DESCRIPTION: "Your account and all your statements will be deleted within 30 days of the deletion request. You can recover your account before this 30-day period by reconnecting. After this period, your account as well as statements, chats, and documents will be permanently deleted.",
      STR_CURRENT_PASSWORD: "Current password",
      STR_UNABLE_TO_DELETE_ASK: "Unable to delete the statement...",
      STR_ASK_DELETED: "Statement deleted",
      STR_ASK_GONA_BE_DELETE: "The statement will be deleted in 30 days.",
      STR_NEW_PASSWORD: "New password",
      STR_CHANGE_PASSWORD: "Change password",
      STR_CONFIRME_PASSWORD: "Confirm password",
      STR_MY_PROFILE: "My account",
      STR_FILTERS: "Filters",
      STR_WHERE_I_M_ASKER: "My statements",
      STR_WHERE_I_M_TARGET: "Statements I'm responsible for",
      STR_WHERE_I_M_SHARED: "Statements shared with me",
      STR_SHOW_ONLY_SOON_DELETED_ASK: "Only statements in the process of deletion",
      STR_HIDE_SOON_DELETED_ASK: "Remove statements in the process of deletion",
      STR_MAIL_NOT_VALIDE: "Invalid email",
      STR_EMAIL_SEND_IF_GOOD_MAIL: "If your email exists, an email will be sent to you to reset your password",
      STR_ENTER_MAIL: "Enter your email",
      STR_PASSWORD_MISS_MATCH: "Different password",
      STR_EMAIL_ALLREADY_USED: "Email already used",
      STR_CONFIRME_EMAIL_HAS_SEND: "A confirmation email has been sent to you",
      STR_CONFIRME_EMAIL_CREATE_ASK: "To confirm the sending of your request ......",
      STR_ASK_SENDED: "Your request has been sent",
      STR_REQUIRED_FIELD: "Required field",
      STR_LOGOUT: "Logout",
      STR_ABOUT: "About",
      STR_ASK: "Statement",
      STR_ASKS: "Statements tracking",
      STR_ASKS_FOOT: "Tracking",
      STR_ANONYMOUS: "Anonymous",
      STR_ANONYMOUS_MODE: "Anonymous mode",
      STR_LANGUAGES: "Languages",
      STR_UNABLE_OFFLINE: "Action impossible in Offline mode",
      STR_OK: "Ok",
      STR_CANCEL: "Cancel",
      STR_RETURN: "Return",
      STR_CLOSE: "Close",
      STR_CONFIRME: "Confirm",
      STR_UNABLE_DELETE_ORIGINAL_ASK_OWNERS: "Unable to delete the original statement of the owner",
      STR_ASK_TRANSFERRED: "Statement transferred",
      STR_NOT_AVAIBLE_NOW: "Not available at the moment",
      STR_TRANSFERT_ASK_TO_USER: "Transfer the statement to the user",
      STR_NOT_AVAIBLE_NOW_DESCRIPTION: "The 'offline mode' is not available at the moment. Please try again with a network connection. If the problem persists, please contact our team.",
      STR_METHODE_CHOICE: "Choose a method",
      STR_DOCUMENT_PICKER: "Explorer",
      STR_USE_CAMERA: "Camera",
      STR_HOW_SHOULD_IMPORT_DOCUMENT: "How would you like to import documents?",
      STR_CHAT: "Chat",
      STR_UNDEFINED_TITLE: "Undefined Title",
      STR_CONTACTS: "Contacts",
      STR_ASK_TITLE: "Statement Title",
      STR_ASK_DESCRIPTION: "Description",
      STR_ASK_EDIT: "Edit the statement",
      STR_ASK_SHOWGEOLOCATION: "Indicate location",
      STR_ASK_GEOLOCATION: "Geolocation",
      STR_ASK_DOCUMENTS: "Attach document(s)",
      STR_ASK_CURRENT_DATE: "Requested on",
      STR_ASK_CREATE_ACCOUNT: "Create an account?",
      STR_ERROR: "An error occurred...",
      STR_FULLDATE: "mm/dd/yyyy hh:ii",
      STR_FULLDATE_SHOW: "mm/dd/yyyy at hh:ii",
      STR_DELETE_AT: "Will be deleted on {Date}",
      STR_CHAT_DELETE_AT: "The request will be deleted on {Date}, from this date it will no longer be accessible",
      STR_FULLDATE_DATETIME_PICKER: "yyyy-mm-ddThh:ii",
      STR_CREA_ASK: "Declare",
      STR_CREA_ASK_TITLE: "New statement",
      STR_SEND: "Send",
      STR_COORDINATES: "Your coordinates",
      STR_FIRSTNAME: "First Name",
      STR_LASTNAME: "Last Name",
      STR_EMAIL: "Email Address",
      STR_PHONE_NUMBER: "Phone Number",
      STR_SOCIETY: "Company",
      STR_PROFESSIONAL_USAGE: "for professional use",
      STR_FAIL_EMAIL: "Please provide a valid email address",
      STR_FAIL_TARGET: "Invalid email or company",
      STR_UNKNOW_SOCIETY: "Unknown company",
      STR_CHAT_DISABLED_WILL_CREATING: "Chat is disabled while composing",
      STR_SUCCESS_CREA_ASK: "Your statement has been successfully created",
      STR_SUCCESS_CREA_MAIL: "Please confirm your request by clicking on the link sent by email",
      STR_PLACEHOLDER: "Enter text",
      STR_PLACEHOLDER_SEARCH: "Search...",
      STR_PLACEHOLDER_FIRSTNAME: "Enter your first name",
      STR_PLACEHOLDER_LASTNAME: "Enter your last name",
      STR_PLACEHOLDER_PASSWORD: "Enter your password",
      STR_PLACEHOLDER_PHONE_NUMBER: "Enter a number",
      STR_DISPLAY_PHONE_NUMBER: "Add my number when making a statement",
      STR_ASKER_PHONE_NUMBER: "Requester's phone number",
      STR_ASKER_PHONE_NUMBER_PLACEHOLDER: "Enter your phone",
      STR_WRONG_PHONE_NUMBER_FORMAT: "Invalid number",
      STR_ENTER_ADDRESSE: "Enter an address or location",
      STR_SCAN: "Scan",
      STR_LOADING: "Loading...",
      STR_NO_GPS: "Please check if your GPS is enabled or check app permissions",
      STR_EMPTY: "Empty",
      STR_NOT_SUPPORTED: "This feature is not supported by your device...",
      STR_NO_PERMISSION: "Permission denied",
      STR_NO_FOLDER_FOUND: "Folder {folder} not found",
      STR_NO_FILE_FOUND: "File {file} not found",
      STR_FILE_ALLREADY_EXIST: "Document already exists",
      STR_UPLOAD_SUCCESS: "Document sent",
      STR_DATA_UPDATE_SUCCESS: "Data updated",
      STR_EQUIPEMENT: "Equipment",
      STR_FILE_ALLREADY_EXIST_SERVER_SIDE: "Document already exists on the server",
      STR_CANT_JOIN_SERVER: "Unable to connect to the server....",
      STR_ERROR_SERVER: "An error occurred on the server...",
      STR_SERVER_SHUTDOWN: "The server has disconnected...",
      STR_WRONG_TOKEN: "The token is invalid or already used...",
      STR_TOKEN_SUCCESS: "Valid",
      STR_INCATIVE_ACCOUNT: "You have not verified your Email",
      STR_PASSWORD_CHANGED: "The password has been changed",
      STR_TOKEN_USERS_SUCCESS: "Account activated...",
      STR_TOKEN_ASKS_SUCCESS: "Request sent",
      STR_WRONG_CREDITENTIAL: "Invalid credentials",
      STR_CONNECTED: "Connected",
      STR_MISSING_IMPOSED_VALUE: "Please fill in all required fields",
      STR_IMPOSED_FIELD: "* Required field",
      STR_EXTERNAL_REFERENCE: "Reference: {Ref}",
      STR_PLEASE_WAIT: "Please wait",
      STR_EDIT: "Edit",
      STR_EDITING: "Editing",
      STR_CREATING: "Waiting for verification (email)",
      STR_NEW: "Requested",
      STR_TODO: "To do",
      STR_RUNNING: "In progress",
      STR_OVER: "Completed",
      STR_ARCHIVED: "Archived",
      STR_ARCHIVE: "Archive",
      STR_ARCHIVE_DESCRIPTION: "Would you like to archive {x} statement(s)?",
      STR_REPORT: "Your report...",
      STR_STATES: "Status",
      STR_RECEIVE_ASK: "Receive this statement",
      STR_RECEIVE: "Receive",
      STR_SAVE: "Save",
      STR_NEW_CONTACT: "New contact",
      STR_CONTACT_DELETED: "Contact deleted",
      STR_CONTACT_DELETE_CONFIRM: "Are you sure you want to delete this contact?",
      STR_DOCUMENT_DELETE_CONFIRM: "Are you sure you want to delete this document?",
      STR_ASK_RECEIVE_CONFIRM: "Are you sure you want to receive this statement?",
      STR_DELETE: "Delete",
      STR_ASK_DELETE_CONFIRM: "Are you sure you want to delete this statement?",
      STR_NEW_CONTACT_DESCRIPTION: "A new contact has been added to your directory",
      STR_CONTACT_CREATED: "Contact created",
      STR_CONTACT_ALREADY_EXIST: "Email already registered in your contacts",
      STR_RECEIVED: "Statement received by {DisplayName}",
      STR_RECEIVED_SHORT: "Received",
      STR_NOT_RECEIVED_SHORT: "Not received",
      STR_USER_HAS_CHANGE_STATE: "Has changed status to: {States}",
      STR_YOU_RECEIVED: "You received this statement",
      STR_TARGET_EMAIL: "Recipient",
      STR_TARGET_EMAIL_PLACEHOLDER: "Enter an email address",
      STR_NO_VALUE_SELECTED: "No value selected",
      STR_BEGIN: "Begin",
      STR_VALIDATE: "Validate",
      STR_YOUR_EMAIL: "Your email address",
      STR_FORGOTTEN_PASSWORDD: "Forgotten password?",
      STR_PLEASE_PROVIDE_TARGET: "You must enter a recipient",
      STR_PLEASE_PROVIDE_YOUR_MAIL: "You must enter your email",
      STR_PLEASE_PROVIDE_YOUR_LASTNAME: "You must enter your last name",
      STR_PLEASE_PROVIDE_TEXT: "You must enter some text",
      STR_DARK_MODE: "Dark mode",
      STR_TERMS: "Terms and Conditions",
      STR_TERMS_ACCEPT: "I acknowledge that I have read and accepted the Terms and Conditions of Use",
      STR_DATA_TRANFERT_ACCEPT: "I authorize the transfer of my data for processing to a third-party software",
      STR_ACCEPT: "Accept",
      STR_TERMS_NOT_ACCEPTED: "Please accept the terms.",
      STR_CONFIDENTIALITY: "Confidentiality",
      STR_LOGO_BASELINE: "Declaration and monitoring of incidents and breakdowns",
      STR_FLAG: "gb",
      STR_VERSION: "Version: {version}",
      STR_ASK_NOT_PRESENT_ON_DEVICE: "The statement is not present on your device. To retrieve it, please create an account or visit the support from which you created the statement.",
      STR_ASK_NOT_PRESENT_ON_DEVICE_HEADER: "Statement not present on the device",
      STR_MODIFICATIONS_SAVED: "Modifications saved",
      STR_SCROLL_TO_ACCEPT: "You must read the Terms and Conditions to be able to validate.",
      STR_ADMIN_VIEW: "Administration",
      STR_ADMINISTRATOR: "Administrator",
      STR_CATEGORY: "Category",
      STR_USERS: "Users",
      STR_MODULE_NOT_FOUND: "Module not found",
      STR_API: "API",
      STR_DISABLED: "Disabled",
      STR_ENABLED: "Enabled",
      STR_CREDITS_LEFT: "Credits remaining: {Credits}",
      STR_ACCOUNT_TYPE_PUBLIC: "Public",
      STR_ACCOUNT_TYPE_ADMIN: "Admin",
      STR_ACCOUNT_TYPE_ACTIVE: "Active",
      STR_ACCOUNT_TYPE_ANONYME: "Anonymous",
      STR_LAST_CONNECTION_DATE: "Last connection",
      STR_CREATED_DATE: "Creation date",
      STR_CGU_UP_TO_DATE: "Up-to-date T&C",
      STR_CGU_ACCEPTED_AT: "T&C accepted on",
      STR_CGU_VERSION: "T&C Version",
      STR_YES: "Yes",
      STR_NO: "No",
      STR_STATUS: "Status",
      STR_ACTIVE: "Active",
      STR_CREDITS: "Credits",
      STR_CREATE: "Create",
      STR_API_IN: "Incoming",
      STR_API_OUT: "Outgoing",
      STR_API_TYPE: "API Type",
      STR_NOT_ADMIN: "You are not an administrator",
      STR_PUBLIC_LABEL: "Public Label",
      STR_INTERNAL_LABEL: "Internal Label (capilog account)",
      STR_API_LINK: "API Link",
      STR_SECURE_CODE: "Security Code",
      STR_ALLREADY_USED: "Already used",
      STR_UNABLE_TO_CREATE: "Unable to create",
      STR_UNABLE_TO_UPDATE: "Unable to update",
      STR_UPDATE_SUCCESS: "Changes saved",
      STR_SUCCESS_CREATE: "Successful creation",
      STR_PENDING_SYNC: "Sync in progress",
      STR_NOT_VERIFIED: "Email not verified, please check your emails",
      STR_PROJET_OWNER_EMAIL: "Project owner's email",
      STR_BASE_ON_TOKEN: "Based on tokens",
      STR_EXPIRE_DATE: "Expiration date",
      STR_KEEP_CONNECTED_FOR: "Stay connected for (HH:MM)",
      STR_STAY_CONNECTED: "Stay connected (weakens the security of your account)",
      STR_INVALID_TOKEN: "Invalid token",
      STR_MANAGE_MY_DEVICES: "Manage my devices",
      STR_MANAGE_DEVICES: "Manage devices",
      STR_CREATED_AT: "Created on {date}",
      STR_UNKNOWN: "Unknown",
      STR_TOKEN_DELETED: "Access deleted",
      STR_DELETE_TOKEN: "Delete access",
      STR_DELETE_TOKEN_DESCRIPTION: "Do you really want to delete this access?",
      STR_SHARED_WITH: "Shared with:",
      STR_SHARE_SUCCESS: "Shared",
      STR_SHARE: "Share",
      STR_VIEW_CONTACT: "View contact",
      STR_ADD_TO_CONTACTS: "Add to contacts",
      STR_SHARE_DELETE_CONFIRM: "Do you really want to delete this share?",
      STR_DELETE_SELECTED_ASKS: "Do you really want to delete {x} selected statement(s)? All runned statements gona be deleted in 30 days.",
      STR_GET_STATEMENT_BACK_TO_OWNER: "Get statement back",
      STR_GET_STATEMENT_BACK_TO_TARGET: "Give statement back",
      STR_VIEW_MY_STATS: "View my statistics",
      STR_USE_OUR_EMAIL_SERVICE: "Use CapiLite email service",
      STR_UPDATE: "Update",
      STR_UPDATER_TITLE_LOW: "Update {NextVersion}",
      STR_UPDATER_MSG_LOW: "An update is available on the store. We recommend you to update your application.",
      STR_UPDATER_TITLE_HIGH: "Update Major {NextVersion}",
      STR_UPDATER_MSG_HIGH: "An update is available. Please update your application to continue using CapiLite.",
      STR_UPDATER_TITLE_MAINTENANCE: "Pending Maintenance",
      STR_UPDATER_MSG_MAINTENANCE: "CapiLite is in maintenance. Please try again later. Thank you for your patience.",
      STR_PASSWORD_TOO_SHORT: "Password too short must be at least 6 characters",
      STR_HAVE_ASKS_TO_VALIDATE: "You have requests waiting for email verification in your emails.",
      STR_HAVE_TO_VALIDATE_ASK: "You have received an email, please confirm the statement from this email",
      STR_PLEASE_ENABLE_CAMERA: "Please enable camera access in your settings",
      STR_INTERLOCUTORS: "Interlocutors",
      STR_TO_COMPLETE: "To complete",
      STR_ATTEMPT_DELETE_X: "Delete {x} statement(s)",
      STR_ATTEMPT_ARCHIVE_X: "Archive {x} statement(s)",
      STR_SUCCESS_ARCHIVE: "Statements archived",
      STR_RECEIVED_ASK: "Statement received",
      STR_NOT_RECEIVED_ASK: "Statement not received",
    }
    // eng:{
    //   STR_FLAG: 'gb'
    // } 
  };

  private manager: ModulesManagerService;

  constructor(private usr: UserService, private tools: ToolsService) {
    usr.Trad = this // on défini l'instance de traduction dans le service user, sinon ca fait un boucle infinie sur la dépencende  user->traduction -> user -> traduction ... donc on le charge dans user quand il s'initialise
    this.checkMissingTrad()
  }

  set Manager(value: ModulesManagerService) {
    this.manager = value;
  }

  get currentLanguage(): string {
    return this.usr.LanguageUser;
  }

  private async checkMissingTrad() {
    // if(!(await this.manager?.Ws.IsDebug())) return
    let notFOund = {}
    let lngs = []
    for (const lgn of Object.keys(this.Translate)) {
      lngs.push(lgn)
      notFOund[lgn] = {}
    }
    let missed = 0
    for (const [str, value] of Object.entries(this.Translate['fra']))
      for (const lng of lngs)
        if (!this.Translate[lng][str]) {
          notFOund[lng][str] = value
          missed++
        }
    if (missed > 0) {
      alert("missed translations")
      this.downloadJsonFile(notFOund, 'data.json', 'application/json');
    }
  }

  downloadJsonFile(jsonData, filename, contentType) {
    const a = document.createElement("a");
    const file = new Blob([JSON.stringify(jsonData, null, 2)], { type: contentType });
    a.href = URL.createObjectURL(file);
    a.download = filename;
    a.click();
  }

  getFlagCode(language: string) {
    return this.Translate[language]['STR_FLAG']
  }

  LanguageAvaible(): Array<string> {
    return Object.keys(this.Translate).sort((a, b) => a.localeCompare(b));
  }

  Parse(Str: string, Replace?: Object): string {
    Replace = typeof Replace != "undefined" && Replace != null ? Replace : {};
    let Text = this.Translate[this.currentLanguage] && this.Translate[this.currentLanguage][Str] != null ? this.Translate[this.currentLanguage][Str] : Str;
    return this.tools.parse(Text, Replace);
  }

  ParseSystemMsg(message: string): string {
    let split = message.replace("#system#", "").split("#")
    let toParse = split.shift() // STR_MSG_TO_PARSE_FOR_MUTLI_LANGUE
    let _arguments = split.shift().split(";;")
    const Replacer = {}
    for (const arg of _arguments) {
      let spl = arg.split(":")
      Replacer[spl[0]] = this.Parse(spl[1])
    }
    return this.Parse(toParse, Replacer)
  }
}
